import { LegacyMigrationMessages, TranslationLegacyMigrationMessages } from "./interfaces";

export const messages: TranslationLegacyMigrationMessages = {
  [LegacyMigrationMessages.legacyMigrationTitle]: "Migración del legado",
  [LegacyMigrationMessages.legacyMigrationNotConfigured]:
    "La migración no está configurada en este ambiente. {{problem}}",
  [LegacyMigrationMessages.legacyMigrationForbidden]:
    "Usted no tiene acceso a la migración del legado. Pida a quien gestiona el acceso.",
  [LegacyMigrationMessages.legacyMigrationSessionExpired]:
    "Su sesión ha expirado. Inicie sesión nuevamente para continuar.",

  [LegacyMigrationMessages.legacyMigrationStepCustomer]: "Cliente",
  [LegacyMigrationMessages.legacyMigrationStepReview]: "Revisión",

  [LegacyMigrationMessages.legacyMigrationChooseTitle]: "¿Qué cliente va a migrar?",
  [LegacyMigrationMessages.legacyMigrationSearchTenant]: "Buscar cliente",
  [LegacyMigrationMessages.legacyMigrationNoTenants]: "Ningún cliente con ese nombre.",
  [LegacyMigrationMessages.legacyMigrationTenantsUnavailable]:
    "No fue posible cargar la lista de clientes.",
  [LegacyMigrationMessages.legacyMigrationInactiveTenant]: "inactivo",
  [LegacyMigrationMessages.legacyMigrationStart]: "Iniciar migración",

  [LegacyMigrationMessages.legacyMigrationReadingTitle]: "Leyendo los usuarios de {{tenant}}…",
  [LegacyMigrationMessages.legacyMigrationReadingHint]:
    "Estamos leyendo la base del CRM antiguo. Tarda unos segundos y allí no se cambia nada.",

  [LegacyMigrationMessages.legacyMigrationReviewTitle]: "{{count}} usuarios de {{tenant}} serán migrados",
  [LegacyMigrationMessages.legacyMigrationSearchUser]: "Buscar correo o nombre",
  [LegacyMigrationMessages.legacyMigrationSelectAll]: "Marcar todos",
  [LegacyMigrationMessages.legacyMigrationClearAll]: "Desmarcar todos",
  [LegacyMigrationMessages.legacyMigrationColumnUser]: "Usuario",
  [LegacyMigrationMessages.legacyMigrationColumnPassword]: "Contraseña",
  [LegacyMigrationMessages.legacyMigrationColumnModules]: "Módulos",
  [LegacyMigrationMessages.legacyMigrationPasswordKept]: "conserva la contraseña (MAYÚSCULAS)",
  [LegacyMigrationMessages.legacyMigrationPasswordReset]: "recibirá correo",
  [LegacyMigrationMessages.legacyMigrationPasswordKeptHint]:
    "En Topcon Suite la contraseña debe escribirse con las letras en MAYÚSCULAS, como la guarda Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationPasswordWeakHint]:
    "La contraseña de Topcon Legado no cumple las reglas de Topcon Suite (de 8 a 64 caracteres, con letras, números y un símbolo). "
    + "El usuario recibe un correo para crear una nueva.",
  [LegacyMigrationMessages.legacyMigrationLockNeedsKeptPassword]:
    "Solo se puede bloquear cuando se conserva la contraseña de Topcon Legado. Sin ella, el usuario quedaría sin acceso a los dos "
    + "sistemas hasta crear la contraseña desde el correo.",
  [LegacyMigrationMessages.legacyMigrationNotContractedBanner]:
    "No contratado para {{tenant}}: {{modules}}. Contrátelo en Tenant Manager antes de migrar; quien solo tiene ese módulo "
    + "no recibe acceso.",
  [LegacyMigrationMessages.legacyMigrationNotContracted]: "no contratado por el cliente — no será liberado",
  [LegacyMigrationMessages.legacyMigrationIneligibleCount]:
    "{{count}} usuarios no pueden ser migrados — ver motivos",
  [LegacyMigrationMessages.legacyMigrationBack]: "Volver",
  [LegacyMigrationMessages.legacyMigrationExportList]: "Exportar lista",
  [LegacyMigrationMessages.legacyMigrationExportListHint]:
    "Planilla con los usuarios que pueden ser migrados, para que el cliente la revise antes de la migración.",
  [LegacyMigrationMessages.legacyMigrationExportListEmail]: "Correo",
  [LegacyMigrationMessages.legacyMigrationExportListStatus]: "Situación",
  [LegacyMigrationMessages.legacyMigrationExportListLockLegacy]: "Bloquear Legado",
  [LegacyMigrationMessages.legacyMigrationExportListNewLegacyPassword]: "Registrar nueva contraseña en el Legado",
  [LegacyMigrationMessages.legacyMigrationConfirm]: "Migrar {{count}} usuarios",
  [LegacyMigrationMessages.legacyMigrationConfirmAction]: "Migrar ahora",
  [LegacyMigrationMessages.legacyMigrationConfirmTitle]: "Confirmar la migración de {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationConfirmBody]:
    "{{count}} usuarios serán creados en Identity y podrán entrar por el login de Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswords]:
    "{{count}} de ellos recibirán un correo para crear la contraseña. Puede ejecutarlo de nuevo después sin duplicar a nadie.",

  [LegacyMigrationMessages.legacyMigrationMigratingTitle]: "Migrando los usuarios de {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationMigratingHint]:
    "Mantenga esta pantalla abierta hasta el final. Si la cierra, la migración se detiene donde esté — quien ya fue migrado permanece en Identity.",
  [LegacyMigrationMessages.legacyMigrationProgress]: "{{done}} de {{count}} usuarios",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFar]: "{{count}} usuarios con error hasta ahora",
  [LegacyMigrationMessages.legacyMigrationStop]: "Detener migración",
  [LegacyMigrationMessages.legacyMigrationStopping]: "Deteniendo…",

  [LegacyMigrationMessages.legacyMigrationDoneTitle]: "¡Listo! {{tenant}} fue migrado",
  [LegacyMigrationMessages.legacyMigrationDoneWithErrorsTitle]:
    "{{tenant}} fue migrado, pero algunos usuarios fallaron",
  [LegacyMigrationMessages.legacyMigrationStoppedTitle]: "La migración de {{tenant}} fue interrumpida",
  [LegacyMigrationMessages.legacyMigrationDoneHint]:
    "Contraseñas conservadas: {{kept}} · Correos de creación de contraseña enviados: {{reset}}.",
  [LegacyMigrationMessages.legacyMigrationStatCreated]: "creados",
  [LegacyMigrationMessages.legacyMigrationStatUpdated]: "actualizados",
  [LegacyMigrationMessages.legacyMigrationStatSkipped]: "sin cambios",
  [LegacyMigrationMessages.legacyMigrationStatErrors]: "errores",
  [LegacyMigrationMessages.legacyMigrationExport]: "Exportar CSV",
  [LegacyMigrationMessages.legacyMigrationRetry]: "Ejecutar de nuevo",

  // The plural forms i18next picks from the `count` option.
  [LegacyMigrationMessages.legacyMigrationReviewTitleZero]:
    "Ningún usuario marcado — marque a quien deba ser migrado",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOne]:
    "{{count}} usuario de {{tenant}} será migrado",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOther]:
    "{{count}} usuarios de {{tenant}} serán migrados",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOne]:
    "1 usuario no puede ser migrado — ver motivo",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOther]:
    "{{count}} usuarios no pueden ser migrados — ver motivos",
  [LegacyMigrationMessages.legacyMigrationConfirmZero]:
    "Ningún usuario marcado",
  [LegacyMigrationMessages.legacyMigrationConfirmOne]:
    "Migrar 1 usuario",
  [LegacyMigrationMessages.legacyMigrationConfirmOther]:
    "Migrar {{count}} usuarios",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOne]:
    "1 usuario será creado en Identity y podrá entrar por el login de Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOther]:
    "{{count}} usuarios serán creados en Identity y podrán entrar por el login de Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsZero]:
    "Todos conservan la contraseña del CRM antiguo. Puede ejecutarlo de nuevo después sin duplicar a nadie.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOne]:
    "1 de ellos recibirá un correo para crear la contraseña. Puede ejecutarlo de nuevo después sin duplicar a nadie.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOther]:
    "{{count}} de ellos recibirán un correo para crear la contraseña. Puede ejecutarlo de nuevo después sin duplicar a nadie.",
  [LegacyMigrationMessages.legacyMigrationProgressOne]:
    "{{done}} de 1 usuario",
  [LegacyMigrationMessages.legacyMigrationProgressOther]:
    "{{done}} de {{count}} usuarios",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOne]:
    "1 usuario con error hasta ahora",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOther]:
    "{{count}} usuarios con error hasta ahora",

  [LegacyMigrationMessages.legacyMigrationOutcomeCreated]: "Creado",
  [LegacyMigrationMessages.legacyMigrationOutcomeUpdated]: "Actualizado",
  [LegacyMigrationMessages.legacyMigrationOutcomeSkipped]: "Sin cambios",
  [LegacyMigrationMessages.legacyMigrationOutcomeError]: "Error",

  [LegacyMigrationMessages.legacyMigrationReasonNoEmail]: "Sin correo en el registro del legado.",
  [LegacyMigrationMessages.legacyMigrationReasonNoAccessRows]: "Sin ningún acceso registrado en el legado.",
  [LegacyMigrationMessages.legacyMigrationReasonNoSsoAccess]: "No tiene derecho en el CRM.",
  [LegacyMigrationMessages.legacyMigrationReasonInOtherTenant]: "Ya existe en Identity en otro cliente ({{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonTopconStaff]: "Cuenta del equipo Topcon (@topconsuite.com): no se migra.",
  [LegacyMigrationMessages.legacyMigrationReasonAlreadyProvisioned]:
    "Ya existía en Identity con esos módulos.",
  [LegacyMigrationMessages.legacyMigrationReasonNoModulesSelected]: "Ningún módulo seleccionado.",
  [LegacyMigrationMessages.legacyMigrationReasonRemovedFromSource]:
    "Eliminado de la base legada después de la revisión.",
  [LegacyMigrationMessages.legacyMigrationReasonEmailChanged]:
    "Correo cambiado en la base legada después de la revisión (ahora {{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonResetEmailFailed]:
    "Cuenta creada, pero el correo de restablecimiento de contraseña no fue enviado.",
  [LegacyMigrationMessages.legacyMigrationReasonProvisionFailed]: "Error al aprovisionar: {{detail}}",
  [LegacyMigrationMessages.legacyMigrationReasonInvalidEmail]: "Correo ausente o inválido.",
  [LegacyMigrationMessages.legacyMigrationReasonNoValidModules]: "Ningún módulo válido de Identity.",

  [LegacyMigrationMessages.legacyMigrationErrorForbidden]:
    "Usted no tiene acceso a la migración del legado. Pida a quien gestiona el acceso.",
  [LegacyMigrationMessages.legacyMigrationErrorTenantNotFound]: "Cliente no encontrado.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotConfigured]:
    "El registro de las bases legadas no está configurado en este ambiente.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotFound]:
    "Este cliente no tiene base legada registrada.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceUnavailable]:
    "No fue posible acceder a la base legada.",
  [LegacyMigrationMessages.legacyMigrationErrorModuleNotContracted]:
    "El cliente no contrató todos los módulos seleccionados.",
  [LegacyMigrationMessages.legacyMigrationErrorInvalidRequest]: "Solicitud inválida.",
  [LegacyMigrationMessages.legacyMigrationErrorUnknown]: "No fue posible concluir la operación.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceAccessDenied]:
    "El usuario de Identity no existe o no tiene permiso en la base de este cliente.",

  [LegacyMigrationMessages.legacyMigrationColumnLegacy]: "Legado",
  [LegacyMigrationMessages.legacyMigrationLock]: "bloquear",
  [LegacyMigrationMessages.legacyMigrationLockAll]: "Bloquear el Topcon Legado de todos",
  [LegacyMigrationMessages.legacyMigrationAlsoUses]: "usa también: {{areas}}",
  [LegacyMigrationMessages.legacyMigrationAlreadyLocked]: "ya bloqueado",
  [LegacyMigrationMessages.legacyMigrationReviewLockHint]:
    "En \"Legado\", quien esté marcado pierde la contraseña del Topcon Legado y pasa a entrar solo por Identity.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocks]:
    "{{count}} perderán la contraseña del Topcon Legado y pasarán a entrar solo por Identity. "
    + "Para devolver el acceso, restablezca la contraseña en el Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOne]:
    "1 perderá la contraseña del Topcon Legado y pasará a entrar solo por Identity. "
    + "Para devolver el acceso, restablezca la contraseña en el Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOther]:
    "{{count}} perderán la contraseña del Topcon Legado y pasarán a entrar solo por Identity. "
    + "Para devolver el acceso, restablezca la contraseña en el Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationLockedSummary]: "Contraseñas del Topcon Legado bloqueadas: {{count}}.",
  [LegacyMigrationMessages.legacyMigrationLockFailed]:
    "{{count}} contraseñas del Topcon Legado no pudieron ser bloqueadas — vea el motivo en el CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOne]:
    "1 contraseña del Topcon Legado no pudo ser bloqueada — vea el motivo en el CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOther]:
    "{{count}} contraseñas del Topcon Legado no pudieron ser bloqueadas — vea el motivo en el CSV.",

  [LegacyMigrationMessages.legacyMigrationLockReasonLocked]: "Contraseña del Topcon Legado bloqueada.",
  [LegacyMigrationMessages.legacyMigrationLockReasonAlreadyLocked]: "El Topcon Legado ya estaba bloqueado.",
  [LegacyMigrationMessages.legacyMigrationLockReasonSkippedPasswordNotKept]:
    "No bloqueado: la contraseña de Topcon Legado no se conservó y el usuario aún no tiene contraseña en Topcon Suite.",
  [LegacyMigrationMessages.legacyMigrationLockReasonPasswordChanged]:
    "No bloqueado: la contraseña fue cambiada en el Topcon Legado durante la migración.",
  [LegacyMigrationMessages.legacyMigrationLockReasonDenied]:
    "No bloqueado: el usuario de Identity no tiene permiso para cambiar contraseñas en esta base.",
  [LegacyMigrationMessages.legacyMigrationLockReasonFailed]:
    "No bloqueado: falla al grabar en el Topcon Legado ({{detail}}).",

  [LegacyMigrationMessages.legacyMigrationManageAccess]: "Gestionar acceso",
  [LegacyMigrationMessages.legacyMigrationAccessTitle]: "Gestionar acceso",
  [LegacyMigrationMessages.legacyMigrationAccessSubtitle]: "Admins que pueden migrar clientes de Topcon Legado a Identity.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantLabel]: "Agregar administrador",
  [LegacyMigrationMessages.legacyMigrationAccessGrant]: "Dar acceso",
  [LegacyMigrationMessages.legacyMigrationAccessRevoke]: "Quitar acceso",
  [LegacyMigrationMessages.legacyMigrationAccessEmpty]: "Nadie tiene acceso todavía.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantedBy]: "Concedido por {{name}} el {{date}}",
  [LegacyMigrationMessages.legacyMigrationAccessLoading]: "Cargando…",
  [LegacyMigrationMessages.legacyMigrationAccessLoadError]: "No fue posible verificar su acceso.",
  [LegacyMigrationMessages.legacyMigrationTryAgain]: "Intentar de nuevo",

  [LegacyMigrationMessages.legacyMigrationSelectShown]: "Marcar los {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationSelectShownOne]: "Marcar este",
  [LegacyMigrationMessages.legacyMigrationSelectShownOther]: "Marcar los {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationClearShown]: "Desmarcar los {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationClearShownOne]: "Desmarcar este",
  [LegacyMigrationMessages.legacyMigrationClearShownOther]: "Desmarcar los {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationFilterAll]: "Todos",
  [LegacyMigrationMessages.legacyMigrationFilterLeftOut]: "Fuera de la migración",
  [LegacyMigrationMessages.legacyMigrationFilterOtherAreas]: "Usan otras áreas",
  [LegacyMigrationMessages.legacyMigrationFilterOnlyCrm]: "Solo CRM",
  [LegacyMigrationMessages.legacyMigrationNoUsersFound]: "No se encontraron usuarios.",
  [LegacyMigrationMessages.legacyMigrationPageRange]: "{{from}}–{{to}} de {{total}}",
  [LegacyMigrationMessages.legacyMigrationPageNext]: "Página siguiente",
  [LegacyMigrationMessages.legacyMigrationPagePrevious]: "Página anterior",
  [LegacyMigrationMessages.legacyMigrationPageGoTo]: "Ir a la página {{page}}",

  [LegacyMigrationMessages.legacyMigrationStaffErrorForbidden]: "Usted no tiene permiso para gestionar este acceso.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorUserNotFound]: "Usuario no encontrado.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorTargetNotAdmin]: "Solo administradores pueden recibir este acceso.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorCannotRevokeSelf]: "Usted no puede quitar su propio acceso.",

  [LegacyMigrationMessages.legacyMigrationStepResult]: "Resultado",
  [LegacyMigrationMessages.legacyMigrationInIdentity]: "ya en Identity",
  [LegacyMigrationMessages.legacyMigrationInIdentityHint]: "Ya existe en Identity. Migrar de nuevo solo agrega lo que falta.",
  [LegacyMigrationMessages.legacyMigrationFilterInIdentity]: "Ya en Identity",
  [LegacyMigrationMessages.legacyMigrationSubtitle]:
    "Traiga los usuarios del CRM (TopSys) a Identity. Ejecutarlo de nuevo es seguro: nadie se duplica.",
  [LegacyMigrationMessages.legacyMigrationChooseHint]:
    "{{count}} clientes. En la revisión, quien ya está en Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintZero]: "Ningún cliente encontrado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOne]: "1 cliente. En la revisión, quien ya está en Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOther]:
    "{{count}} clientes. En la revisión, quien ya está en Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationReviewHint]:
    "Desmarque a quien no deba ir; quien ya está en Identity empieza desmarcado. Quien tiene en Topcon Legado una contraseña dentro "
    + "de las reglas de Topcon Suite la conserva, escribiéndola en MAYÚSCULAS; los demás reciben un correo para crear una nueva.",
  [LegacyMigrationMessages.legacyMigrationLeave]: "Volver al inicio"
};
